// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__I7PAa","rootSmall":"AddTileButton_rootSmall__1o8Yi"};